import { Query } from 'react-apollo'
import loans, { Loans, LoansInput, IFragmentBasicLoanFields } from '../../graphql/queries/loans'
import withQuery from './withQuery'
import { GetProps } from '../../types'

class LoansQuery extends Query<Loans, LoansInput> {}

const LoansQueryCompleted = withQuery(loans)(LoansQuery)

export type LoansQueryProps = GetProps<typeof LoansQueryCompleted>
export type LoansQueryResult = Loans
export type Loan = IFragmentBasicLoanFields

export default LoansQueryCompleted



// WEBPACK FOOTER //
// ./src/components/queries/LoansQuery.tsx